import { connect } from 'react-redux';
import { getFetching } from '../../redux/Guest/selectors/reservation';
import { getGuestReservationSearchQuery } from '../../redux/Guest/selectors/components/reservation-search';
import { updateGuestReservationSearchQuery } from '../../redux/Guest/actions/components/reservation-search';
import { clearGuestReservations } from '../../redux/Guest/actions/reservation';
import { fetchGuestReservations } from '../../redux/Guest/sagas/routines';
import ReservationSearch from '../../components/guest/ReservationSearch';
import { getPaginationQueryOptions } from '../../redux/Guest/selectors/reservation/pagination';
import * as Status from '../../constants/reservation/Status';
import StatusLabels from '../../constants/reservation/StatusLabels';

function mapStateToProps(state, props) {
  const searchQuery = getGuestReservationSearchQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getFetching(state),
    statusOptions: [
      { value: Status.PENDING, label: StatusLabels[Status.PENDING] },
      { value: Status.ACTIVE, label: StatusLabels[Status.ACTIVE] },
      { value: Status.CONFIRMED, label: StatusLabels[Status.CONFIRMED] },
      { value: Status.REJECTED, label: StatusLabels[Status.REJECTED] },
      { value: Status.CANCELED, label: StatusLabels[Status.CANCELED] },
      { value: Status.COMPLETED, label: StatusLabels[Status.COMPLETED] }
    ]
  };
}

function mapDispatchToProps(dispatch, { guestId }) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearGuestReservations());
      dispatch(fetchGuestReservations({ guestId, query: queryOptions }));
    },
    onChange: query => {
      dispatch(updateGuestReservationSearchQuery(query));
    },
    onReset: defaultQuery => {
      dispatch(clearGuestReservations());
      dispatch(fetchGuestReservations({ guestId, query: defaultQuery }));
      dispatch(updateGuestReservationSearchQuery(defaultQuery));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationSearch);
